import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Seo } from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-5" data-testid="payment-cancel-page">
      <Seo title="Checkout Cancelled — The Hoodie Project®" />
      <div className="w-full max-w-md border border-border p-10 text-center">
        <XCircle className="mx-auto h-12 w-12" />
        <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tighter">CHECKOUT CANCELLED</h1>
        <p className="mt-3 text-sm text-muted-foreground">No worries — your bag is still saved. Pick up where you left off.</p>
        <Link to="/cart" className="mt-8 inline-block bg-white px-8 py-4 text-xs font-bold tracking-[0.2em] text-black hover:bg-neutral-300">BACK TO BAG</Link>
      </div>
    </div>
  );
}
